import { render, staticRenderFns } from "./adminData.vue?vue&type=template&id=69cb496f"
import script from "./adminData.vue?vue&type=script&lang=js"
export * from "./adminData.vue?vue&type=script&lang=js"
import style0 from "./adminData.vue?vue&type=style&index=0&id=69cb496f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports